import Image from '@/components/Image';
import { Container } from '@/components/layout/Container';
import { COLORS } from '@/styles/color';
import { mediaBreakpointUp, paddingY, square } from '@/styles/layout/utils';
import { FONT_WEIGHTS } from '@/styles/typography';
import { customTextSize, remCalc } from '@/styles/typography/utils';
import styled from 'styled-components';

const Section = styled.section`
  ${paddingY(30)}

  ${mediaBreakpointUp('tablet')} {
    ${paddingY(60)}

    ${Container} {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
    }
  }
`;

const Logo = styled(Image) <{ taller: boolean }>`
  width: auto;
  height: ${(props) => (props.taller ? 53 : 40)}px;
  margin-top: ${remCalc(20)};
`;

const Quote = styled.blockquote<{ hasImage: boolean }>`
  position: relative;
  ${customTextSize(24, 30)}
  letter-spacing: -0.01em;
  padding-left: ${remCalc(30)};
  color: ${COLORS.BLACK};

  &::before {
    content: '“';
    position: absolute;
    top: 14px;
    left: -2px;
    font-size: 70px;
  }

  footer {
    margin-top: ${remCalc(40)};
    margin-left: ${(props) => remCalc(props.hasImage ? -30 : 0)};
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: ${remCalc(20)};
  }

  ${mediaBreakpointUp('tablet')} {
    grid-column: 1 / -1;
    ${customTextSize(32, 40)}
  }

  ${mediaBreakpointUp('desktopWide')} {
    grid-column: 3 / -3;
  }
`;

const AuthorImage = styled.div`
  ${square(73)}
  border-radius: 100%;
  overflow: hidden;

  ${mediaBreakpointUp('tablet')} {
    ${square(115)}
  }
`;

const AuthorNameTitle = styled.p`
  ${customTextSize(16, 24)}

  span {
    display: block;
    margin-bottom: 4px;
  }

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 30)}
  }

  ${mediaBreakpointUp('desktop')} {
    &,
    strong {
      ${customTextSize(24, 30)}
    }
  }
`;

const AuthorCompanyName = styled.span`
  ${customTextSize(16, 24)}
  font-weight: ${FONT_WEIGHTS.SEMIBOLD};
  margin-top: 10px;

  ${mediaBreakpointUp('tablet')} {
    ${customTextSize(24, 30)}
  }

  ${mediaBreakpointUp('desktop')} {
    ${customTextSize(24, 30)}
  }
`;

const glowQuoteComponents = {
  Section,
  Logo,
  Quote,
  AuthorImage,
  AuthorNameTitle,
  AuthorCompanyName,
};

export default glowQuoteComponents;
